// extracted by mini-css-extract-plugin
export default {"container":"newServices_container__Wrdif","new-services":"newServices_new-services__I3En-","sidebar":"newServices_sidebar__TGEH-","events":"newServices_events__CDEks"};